import defaults from './default.constants';

export const featuresConstants = {
  ...defaults.rsf('get', 'features'),
  ...defaults.rsf('update', 'features'),
  ...defaults.rsf('all', 'features'),
};
